import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert,  Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form'

import svgWait2 from './svg/wait2.gif'


import { FBSClosingInfo, FBSClosingUpdate } from '../Types'
import { SystemHeader } from '../CommonUI';


interface PageInfo {
    n: number
}

var GsbFlag: any;

interface ClosingUpdateViewProps {
    gsb: AxiosInstance,
    data: FBSClosingInfo[],
    baseUrl?: string,
    token?: string | null,
    onEdit?: () => void,
}

function ClosingUpdateView({ gsb, data = {} as FBSClosingInfo[], baseUrl = "", token = "", onEdit = () => {}}: ClosingUpdateViewProps) {
   
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("set StatusList: ", StatusList)

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, data])

    return (
        <div>
            <div className="Row">
                <Button className="Col-1-1" disabled={true} icon="direction-left">Prev</Button>
                <Button className="Col-2-1" disabled={true} icon="add">New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete">Delete</Button>
                <Button className="Col-5-1" disabled={true} icon="direction-right">Next</Button>
                
            </div>
            <div className="Spacing-V-16" />
            <HTMLTable interactive>
                <thead>
                    <th className="TCol-100">Comdy</th>
                    <th className="TCol-100">D.Month</th>
                    <th className="TCol-100">Call / Put</th>
                    <th className="TCol-100"><div className="Align-R">Strike</div></th>
                    <th className="TCol-100"><div className="Align-R">Price</div></th>
                </thead>
                <tbody>
                    {data.map((clsInfo, i) =>
                        <tr>
                            <td>{clsInfo.d_Comdy}</td>
                            <td>{clsInfo.d_DMon}</td>
                            <td>{clsInfo.d_CallPut}</td>
                            <td><div className="Align-R">{clsInfo.d_Strike}</div></td>
                            <td><div className="Align-R">{clsInfo.d_Price}</div></td>
                        </tr>
                    )}
                </tbody>
            </HTMLTable>
        </div>
    )
}

interface ClosingUpdateEditProps {
    gsb: AxiosInstance,
    data?: FBSClosingInfo[],
    isNew?: boolean,
    onSave?: (data: FBSClosingUpdate) => void,
    onCancel?: () => void;
}

function ClosingUpdateEdit({ gsb, data = {} as FBSClosingInfo[], isNew = false, onSave = () => { }, onCancel = () => { } }: ClosingUpdateEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSClosingUpdate>()
  
    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        //register({ name: "d_status" })
    }, [register])
    
    useEffect(() => {

         if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])    

    const onSubmit = (data: FBSClosingUpdate) => {
        //console.log("onsubmit called", data)
        // put value to json/field before write database dbf

        (async () => {
            try {
                onSave(data)
            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
            </div>
            <div className="Spacing-V-16" />
            <HTMLTable interactive condensed>
                <thead>
                    <th className="TCol-100">Comdy</th>
                    <th className="TCol-100">D.Month</th>
                    <th className="TCol-100">Call / Put</th>
                    <th className="TCol-100"><div className="Align-R">Strike</div></th>
                    <th className="TCol-100"><div className="Align-R">Price</div></th>
                </thead>
                <tbody>
                    {data.map((clsInfo, i) =>
                        <tr>
                            <td><InputGroup disabled name={`comdy[${i}]`} defaultValue={clsInfo.d_Comdy} inputRef={register}/></td>
                            <td><InputGroup disabled name={`dmon[${i}]`} defaultValue={clsInfo.d_DMon} inputRef={register}/></td>
                            <td><InputGroup disabled name={`callput[${i}]`} defaultValue={clsInfo.d_CallPut} inputRef={register}/></td>
                            <td><InputGroup disabled={clsInfo.d_CallPut === ""} type="number" name={`strike[${i}]`} defaultValue={clsInfo.d_Strike} inputRef={register}/></td>
                            <td><InputGroup type="number" name={`price[${i}]`} defaultValue={clsInfo.d_Price} inputRef={register}/></td>
                        </tr>
                    )}
                </tbody>
            </HTMLTable>
        </form>
    )
}

interface ClosingUpdateMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function ClosingUpdateMain({ gsb }: ClosingUpdateMainProps) {
    const [data, setData] = useState([] as FBSClosingInfo[])
    const [currentMode, setCurrentMode] = useState("show")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "Closing",
                        cAction: "ListMulti",
                    });
                setData(res.data.data)
                setCurrentMode("show")
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    const editOnSave = async (ccyParams: FBSClosingUpdate) => {
        try {
            console.log("call editOnSave", ccyParams)
            const res = await gsb.post('/fbs/Master', {sb_data: ccyParams, cPgmId: "Closing", cAction: "UpdateMulti"})
            utils.showSuccess("Records updated")
            setData(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    // currentMode = show
    let detail = <ClosingUpdateView gsb={gsb} data={data} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onEdit={() => setCurrentMode("edit")}></ClosingUpdateView>
    switch (currentMode) {
        case "edit":
            detail = <ClosingUpdateEdit gsb={gsb} data={data} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></ClosingUpdateEdit>
            break
    }

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    
    
    return (
        <>
            <form >
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Closing Price</H3>
                    {detail}
                </Card>
            </form>
        </>
    );
}

export default ClosingUpdateMain